import { CheckCircle } from 'lucide-react';

export default function Admissions() {
  const handleEnroll = () => {
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSdCRhoQCfF_9QNWPYQ-nPd1UTEWGlL4j7n4XSHVeX-HTE0_-g/viewform?usp=publish-editor', '_blank');
  };

  const steps = [
    {
      number: '01',
      title: 'Visit Us',
      description: 'Schedule a campus visit to see our facilities and meet our team'
    },
    {
      number: '02',
      title: 'Interaction',
      description: 'Have a discussion about your child\'s needs and our programs'
    },
    {
      number: '03',
      title: 'Registration',
      description: 'Complete enrollment and secure a spot for your child'
    },
  ];

  return (
    <section id="admissions" className="py-16 sm:py-24 bg-purple-primary">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold font-display text-white mb-4">
            Easy <span className="text-pink-light">Admissions</span>
          </h2>
          <p className="text-white/90 text-base sm:text-lg max-w-2xl mx-auto">
            Simple 3-step process to secure admission for your child
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16">
          {steps.map((step, index) => (
            <div key={index} className="group">
              {/* Step Card */}
              <div className="relative bg-white rounded-2xl p-6 sm:p-8 shadow-soft hover:shadow-lg transition-all duration-300 h-full">
                {/* Step Number */}
                <div className="text-5xl sm:text-6xl font-bold font-display text-purple-primary/30 mb-4">
                  {step.number}
                </div>

                {/* Content */}
                <div className="relative z-10">
                  <h3 className="text-xl sm:text-2xl font-bold text-gray-800 mb-2 font-display">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
                    {step.description}
                  </p>
                </div>

                {/* Checkmark */}
                <div className="absolute top-4 sm:top-6 right-4 sm:right-6 text-purple-primary opacity-20 group-hover:opacity-40 transition-opacity">
                  <CheckCircle size={40} />
                </div>
              </div>

              {/* Arrow - hidden on mobile and last item */}
              {index < steps.length - 1 && (
                <div className="hidden md:flex justify-center mt-6 sm:mt-8">
                  <div className="text-3xl text-gray-300">→</div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Important Info */}
        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-soft mb-8 sm:mb-12">
          <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-4 font-display">
            📋 Enrollment For
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm sm:text-base text-gray-600">
            <div>✓ Nursery to Grade 5</div>
            <div>✓ Year 2026-27</div>
            <div>✓ After-school program</div>
            <div>✓ Skill development courses</div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="bg-white rounded-2xl p-8 sm:p-12 text-center shadow-lg">
          <h3 className="text-2xl sm:text-3xl font-bold text-purple-dark mb-4 font-display">
            Ready to Join Kinder Heaven?
          </h3>
          <p className="text-gray-600 mb-6 text-sm sm:text-base max-w-2xl mx-auto">
            Enroll now for 2026-27 and give your child personalized academics, skill development, and holistic growth!
          </p>
          <button onClick={handleEnroll} className="bg-purple-primary text-white px-8 sm:px-10 py-3 sm:py-4 rounded-2xl font-bold text-base sm:text-lg hover:shadow-lg transform hover:scale-105 transition-all duration-300 hover:bg-purple-dark">
            Enroll Now
          </button>
        </div>
      </div>
    </section>
  );
}
